import { render } from "./SpreadScale.vue?vue&type=template&id=6be3c627&scoped=true"
import script from "./SpreadScale.vue?vue&type=script&lang=js"
export * from "./SpreadScale.vue?vue&type=script&lang=js"

import "./SpreadScale.vue?vue&type=style&index=0&id=6be3c627&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be3c627"]])

export default __exports__